"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNREAD_MESSAGES_COUNT_KEY = exports.MESSAGE_SECTIONS_KEY = exports.TIMEOUT_MARK_ALL_AS_READ = void 0;
exports.TIMEOUT_MARK_ALL_AS_READ = 2000;
exports.MESSAGE_SECTIONS_KEY = 'vp-ue-messages';
exports.UNREAD_MESSAGES_COUNT_KEY = 'vp-ue-unread-messages-count';
